export const parseValidStatus = (valid: boolean | null): string | null => {
  if (valid === null) {
    return valid;
  }
  return valid ? 'Valid' : 'Invalid';
};
